<template>
	<div class="sld_login" :style="{background:loadpageColor}" >
		<div class="sld_login_header">
			<div class="content" >
				<router-link  class="l_logo" :to="`/`">
					<!-- <img class="img" :src="configInfo.main_site_logo" :onerror="defaultImg" alt /> -->
					<img class="img" src="../../../assets/common_top_logo.png" :onerror="defaultImg" alt />
				</router-link>
				<!-- <button @click="goToPage('/weixin')">微信扫码登录</button> -->
				<!-- <div class="r_register_wrap">
					{{ L['还没注册？'] }}
					<a class="go_register_btn" href="javascript:void(0)" @click="goToPage('/register')">{{ L['去注册']
					}}</a>
				</div> -->
			</div>
		</div>
		<div class="sld_login_content" :style="{background:loadpageColor}" >
			<img @click.stop="diyNavTo(loadInfo)"   class="bg" :src="loadImg"  alt />
			<div class="login" @click.stop="diyNavTo(loadInfo)">
				<div class="login_box" @click.stop
				:style="!resetPasswordVisible && !QRcodeLogin && (loginType == 2 || loginType == 1) ? { height: '692px' } : {}"
				>
					<div class="qrLogin" 
					@mouseover="showTooltip(1)" @mouseout="hideTooltip(1)"
					@click="changeQrlog" v-if="appEnable == 1 && !resetPasswordVisible">
						<div class="make_shadow">
							<!-- <dynaIcon class="qrLeft" :src="QRcodeLogin ? idCode : qrCode" width="54" height="54" color="--color_main">
							</dynaIcon> -->
							<img style="width: 73px; height: 73px; margin-top: 7px;" v-if="!QRcodeLogin && isHoveredPic == false" src="../../../assets/user/defeat_qr.png" alt="">
							<img style="width: 73px; height: 73px; margin-top: 7px;" v-if="QRcodeLogin && isHoveredPic == false" src="../../../assets/user/defeat_pc.png" alt="">
							<img style="width: 73px; height: 73px; margin-top: 7px;" v-if="!QRcodeLogin &&isHoveredPic == true" src="../../../assets/user/mouse_qr.png" alt="">
							<img style="width: 73px; height: 73px; margin-top: 7px;" v-if="QRcodeLogin && isHoveredPic == true" src="../../../assets/user/mouse_pc.png" alt="">
						</div>
					</div>

					<!-- 提示语start -->
					 <div class="remind_user_one" 
					 v-if="!QRcodeLogin && isTooltipVisible">
							扫码登录
						</div>
						<div class="remind_user_two" 
						v-if="QRcodeLogin && isTooltipVisible" >
							验证码/密码登录
						</div>
					<!-- 提示语end -->

					<template v-if="!resetPasswordVisible">
						<template v-if="!QRcodeLogin">
						<div 
						@mouseover="showTooltip(3)" @mouseout="hideTooltip(3)"
						class="top_title title_log" style="padding-left: 30px;">登录</div>
						<!-- 新增：切换到重置密码界面按钮 -->
   					<!-- <button @click="changeToResetPassword">重置密码</button> -->
						<div class="center">
							<template v-if="loginType == 1">
								<div class="item account">
									<!-- <span style="color: #BBB;font-size: 19px;padding-top: 7px" class="icon iconfont iconwode"></span> -->
									<input type="text" v-model="name" :placeholder="L['用户名/手机号']" class="input" autocomplete="off" />
									<!-- <div data-type="userName" class="cancel" @click="clearInputVal('name')">
										<span style="color: #bbb;" class="iconfont iconcuowu"></span>
									</div> -->
								</div>
								<div class="item password">
									<!-- <span style="color: #BBB;font-size: 21px;padding-top: 7px" class="icon iconfont iconmima1"></span> -->
									<input 
									:type="passwordFieldType"
									v-model="password" :placeholder="L['密码']" class="input"
										autocomplete="new-password" />
									<div data-type="password" class="cancel" @click="togglePasswordVisibility('old')">
										<img v-if="!showPassword" src="../../../assets/user/hide.png" alt="" class="icon_user">
										<img v-if="showPassword" src="../../../assets/user/visible.png" alt="" class="icon_user">
									</div>
									<!-- <div data-type="password" class="cancel" @click="clearInputVal('password')">
										<span style="color: #bbb" class="iconfont iconcuowu"></span>
									</div> -->
								</div>
							</template>
							<template v-if="loginType == 2">
								<div class="item account">
									<!-- <span style="color: #BBB;font-size: 21px;padding-top: 7px" class="icon iconfont iconshouji2"></span> -->
									<input type="text" v-model="name" :placeholder="L['手机号']" class="input" autocomplete="off" />
									<div v-if="name" data-type="userName" class="cancel" @click="clearInputVal('name')">
										<img src="../../../assets/user/close.png" alt="" class="icon_user">
									</div>
									<!-- <div data-type="userName" class="cancel" @click="clearInputVal('name')">
										<span style="color: #bbb;" class="iconfont iconcuowu"></span>
									</div> -->
								</div>
								<div class="item password">
									<!-- <span style="color: #BBB;font-size: 18px;padding-top: 8px" class="icon iconfont iconyanzhengma2"></span> -->
									<input type="text" v-model="smsCode" :placeholder="L['短信验证码']" class="input" autocomplete="off" />
									<div v-if="smsCode" data-type="userName" class="cancel" @click="clearInputVal('smsCode')" style="right: 157px;">
										<img src="../../../assets/user/close.png" alt="" class="icon_user">
									</div>
									<button 
									:class="{ 'active-button': isSmsButtonActive && !countDownM }"
     							:disabled="!isSmsButtonActive || countDownM"
									href="javascript:void(0);" class="send_code" @click="getSmsCode">{{
										countDownM ? countDownM + L['s'] : (hasSentCode ? L['重新获取'] : L['获取验证码'])
									}}</button>
								</div>
							</template>
							
							<!-- <div class="error"> -->
								<span 
								class="error_tip"
								v-if="errorMsg" 
								:style="{ display: errorMsg ? '' : 'none' }"
								style="color: #FF483E ;font-size: 12px" >
							{{ errorMsg }}
							</span>
								
								<span 
								class="error_tip"
								v-if="loginType == 2 && !errorMsg"
								style="color: #888E98;">{{ L['未注册的手机号码，系统将自动为您创建账号'] }}</span>
							<!-- </div> -->
							<!-- 协议告知start -->
							<div class="agreement" style="width: 407px;">
								<div class="agree_box" v-if="agreeWx">
									请先同意相关条款
								</div>
								<div class="agreement-item agreement-header" >
									<input type="checkbox" id="agreeAll" v-model="allAgreed" @change="toggleAll" />
									<span class="checkbox-custom_all"></span>
									<label for="agreeAll">我同意以下全部选项：</label>
								</div>
								<div class="agreement-content">
									<div class="agreement-item">
										<input type="checkbox"  id="privacy" v-model="privacyAgreed" />
										<span class="checkbox-custom"></span>
										<label for="privacy">我已阅读并同意
											<router-link target="_blank" class="link" :to="`/agreement?type=3`">{{
												L['《华硕会员隐私说明》'] }}
											</router-link>
											<span>及</span>
											<router-link target="_blank" class="link" :to="`/agreement?type=2`">{{
												L['《隐私政策&说明》'] }}
											</router-link>
											<!-- <span class="link">《华硕会员隐私说明》</span><span class="link">《隐私政策&说明》</span> -->
											<!-- <a href="https://www.asus.com/Privacy-Policy" target="_blank" class="link">《华硕会员隐私说明》</a> -->
										</label>
									</div>
									<div class="agreement-item">
										<input type="checkbox" id="terms" v-model="termsAgreed"  />
										<span class="checkbox-custom"></span>
										<label for="terms">我已阅读并同意 
											<router-link target="_blank" class="link" :to="`/agreement?type=1`">{{
												L['《华硕使用条款》'] }}
											</router-link>
										</label>
									</div>
									<div class="agreement-item" style=" align-items: flex-start;">
										<input type="checkbox" id="age" v-model="ageAgreed" />
										<span class="checkbox-custom"></span>
										<label for="age" class="label_items">我已年满十四岁(基于保障未成年的隐私权益，华硕不会透过本服务搜集未满十四周岁未成年人的个人信息)</label>
									</div>
								</div>
							</div>
							<!-- 协议告知end -->
							<a href="javascript:void(0)"
							:disabled="!isFormValid" 
							:class="{ 'login_btn': true, 'disabled': !isFormValid}" 
							@click="login" class="login_btn">{{
								L['登录']
							}}</a>

							<!-- 登录方式start -->
							<div style="display: flex;justify-content:space-between; align-items: center; top: 20px;">
								<div @click="changeToResetPassword" class="log_method"
								style="margin: 0;" v-if="loginType == 1" >{{L['忘记密码?']}}</div>
								<!-- <router-link  
								v-if="loginType == 1" 
								:to="`/pwd/forget`" class="log_method">{{
									L['忘记密码?']
								}}</router-link> -->
								
								<!-- <router-link  
								v-if="loginType == 2" 
								:to="`/pwd/forget`" class="log_method">{{
									L['收不到验证码？']
								}}</router-link> -->
								<div 
								v-if="loginType == 2" 
								class="log_method" type="text" @click="handleConfirmOpen" style="padding: 0px">收不到验证码？</div>
								<div v-if="loginType == 2" 
								class="log_method"
								style="margin: 0;"
								:class="{ item: true, active: loginType == 1 }" @click="changeLoginType(1)">
									{{ L['账号密码登录'] }}
								</div>
								<div v-if="loginType == 1" 
								class="log_method"
								style="margin: 0;"
								:class="{ item: true, active: loginType == 2 }" @click="changeLoginType(2)">
									{{ L['验证码登录'] }}
								</div>
						</div>
							<!-- 登录方式end -->
							
						</div>
						<!-- <div class="top">
							<div :class="{ item: true, active: loginType == 1 }" @click="changeLoginType(1)">
								{{ L['账号登录'] }}
							</div>
							<div :class="{ item: true, active: loginType == 2 }" @click="changeLoginType(2)">
								{{ L['手机登录'] }}
							</div>
						</div> -->
						</template>
						
						<template v-else>
							<div v-if="currentLoginMethod === 'app'">
								<div class="top_title title_log" style="padding-left: 30px;">扫码登录</div>
								<div class="qrMain">
									<div class="qrMain_code">
										<div class="qrMain_code_bg" :style="`filter:blur(${QRout ? '1px' : '0'
												});background-image:url(${QRlogShow});background-size:112% 112%;background-position:center;`
												"></div>
										<div v-if="QRout" class="qrMain_code_cover">
											<p>{{ L['二维码过期'] }}</p>
											<div @click="reCreateQRcode">{{ L['刷新'] }}</div>
										</div>
										<div v-else-if="QRsuccess" class="qrMain_code_cover">
											<img class="qrMain_code_success" src="../../../assets/user/reset_password.png" alt="">
											<p class="qrMain_code_cover_p">{{ L['登录成功'] }}</p>
										</div>
										<div v-else-if="QRScansuccess" class="qrMain_code_cover">
											<img class="qrMain_code_success" src="../../../assets/user/reset_password.png" alt="">
											<p class="qrMain_code_cover_p">{{ L['扫码成功'] }}</p>
										</div>
									</div>
									<p class="qrMain_title">{{ L['使用华硕商城APP扫码登录'] }}
										<span style="display: inline-block; width: 5px;"></span>
										<img 
										@mouseenter="showTooltip(2)" @mouseleave="hideTooltip(2)"
										class="question_icon" src="../../../assets/user/question.png" alt="">
										<span class="reply_user" v-if="isReplyVisible">
											<span class="reply_itemO">如何用华硕商城APP扫码</span>
											<span class="reply_itemT">答：点击手机-打开华硕商城APP-首页右上角扫一扫</span>
										</span>
									</p>
									
									<!-- <div class="qrMain_tips">
										<div class="qrMain_tips_item">
											<span style="color:#999999;font-size:16px;" class="icon iconfont iconzhuce-mianshuru"></span>
											<span>{{ L['免输入'] }}</span>
										</div>
										<div class="qrMain_tips_item">
											<span style="color:#999999;font-size:16px;" class="icon iconfont icongenganquan"></span>
											<span>{{ L['反应快'] }}</span>
										</div>
										<div class="qrMain_tips_item">
											<span style="color:#999999;font-size:16px;" class="icon iconfont icona-kuaijin1"></span>
											<span>{{ L['更安全'] }}</span>
										</div>
									</div> -->
								</div>

							</div>
						
							<!-- <div v-if="currentLoginMethod === 'wechat'">
								<div class="top_title title_log" style="padding-left: 30px;">微信扫码登录</div>
									<div class="qrMain">
										<div class="qrMain_code">
											<div class="qrMain_code_bg" :style="`filter:blur(${wxQRout ? '1px' : '0'
													});background-image:url(${wxQRlogShow});background-size:112% 112%;background-position:center;`
													"></div>
											<div v-if="wxQRout" class="qrMain_code_cover">
												<p>{{ L['二维码过期'] }}</p>
												<div @click="wxreCreateQRcode">{{ L['刷新'] }}</div>
											</div>
											<div v-else-if="wxQRsuccess" class="qrMain_code_cover">
												<img class="qrMain_code_success" src="../../../assets/user/reset_password.png" alt="">
												<p class="qrMain_code_cover_p">{{ L['扫码成功'] }}</p>
											</div>
										</div>
										<p class="qrMain_title">{{ L['使用微信APP扫码登录'] }}
										</p>
									</div>
							</div>						 -->
						</template>
					</template>
					
					<!-- 重置密码界面 start-->
					<template v-if="resetPasswordVisible">
						<div class="top_title title_log">重置密码</div>
						<div class="reset_password">
							<!-- 重置密码界面的内容 -->
							
							<!-- Step 1: 输入用户名/手机号 -->
							<template v-if="currentStep === 1">
								<div class="center">
									<div class="item account">
										<input type="text" v-model="name" :placeholder="L['用户名/手机号']" class="input" autocomplete="off" @input="validateInput('name')" />
										<!-- <div v-if="name" data-type="userName" class="cancel" @click="clearInputVal('name')">
											<img src="../../../assets/user/close.png" alt="" class="icon_user">
										</div> -->
									</div>
									<a href="javascript:void(0)"
									:disabled="!isUsernameOrPhoneValid"
									:class="{ 'login_btn': true, 'disabled': !isUsernameOrPhoneValid}" 
									@click="nextStep" class="login_btn">{{
										L['下一步']
									}}</a>
									<!-- <button class="login_btn btn_total" :disabled="!isUsernameOrPhoneValid" @click="nextStep">{{ L['下一步'] }}</button> -->
								</div>
							</template>
							<!-- Step 2: 获取验证码 -->
							<template v-else-if="currentStep === 2">
								<div class="center">
									<div class="item account">
										<input type="text" v-model="name" :placeholder="L['用户名/手机号']" class="input" autocomplete="off" />
										<!-- <div v-if="name" data-type="userName" class="cancel" @click="clearInputVal('name')">
											<img src="../../../assets/user/close.png" alt="" class="icon_user">
										</div> -->
									</div>
									<div class="item password">
										<input type="text" v-model="verificationCode" :placeholder="L['短信验证码']" class="input" autocomplete="off"  />
										<button 
										:class="{ 'active-button': isSmsButtonActive && !countDownM }"
     								:disabled="!isSmsButtonActive || countDownM"
										href="javascript:void(0);" class="send_code" @click="getSmsCode">{{
											countDownM ? countDownM + L['s'] : (hasSentCode ? L['重新获取'] : L['获取验证码'])
										}}</button>
									</div>
									<span v-if="errorMsg" style="color:#FF483E ;" class="error_tip">{{ errorMsg }}</span>
									<a href="javascript:void(0)"
									:disabled="!isVerificationCodeValid"
									:class="{ 'login_btn': true, 'disabled': !isVerificationCodeValid}" 
									@click="nextStep" class="login_btn">{{
										L['下一步']
									}}</a>
									<!-- <button class="login_btn btn_total" :disabled="!isVerificationCodeValid" @click="verifyCode">{{ L['下一步'] }}</button> -->
									<!-- 登录方式start -->
									<div style="display: flex;justify-content:space-between; align-items: center; top: 20px;">							
										<div class="log_method" type="text" @click="handleConfirmOpen">收不到验证码？</div>
									</div>
									<!-- 登录方式end -->
								</div>
							</template>

							<!-- Step 3: 设置新密码 -->
							<template v-else-if="currentStep === 3">
								<!-- <div class="top_title title_log">设置新密码</div> -->
								<div class="center">
									<div class="item password">
										<input :type="newPasswordFieldType" v-model="newPassword" :placeholder="L['设置新密码']" class="input" autocomplete="new-password" @input="validateInput('newPassword')" />
										<div data-type="password" class="cancel" @click="togglePasswordVisibility('new')">
											<img v-if="!showNewPassword" src="../../../assets/user/hide.png" alt="" class="icon_user">
											<img v-if="showNewPassword" src="../../../assets/user/visible.png" alt="" class="icon_user">
										</div>
									</div>
									<div class="item password">
										<input :type="confirmNewPasswordFieldType" v-model="confirmPassword" :placeholder="L['再次输入新密码']" class="input" autocomplete="new-password" @input="validateInput('confirmPassword')" />
										<div data-type="password" class="cancel" @click="togglePasswordVisibility('confirm')">
										<img v-if="!showConfirmPassword" src="../../../assets/user/hide.png" alt="" class="icon_user">
										<img v-if="showConfirmPassword" src="../../../assets/user/visible.png" alt="" class="icon_user">
									</div>
									</div>
									<!-- <span v-if=""  style="color:red;" class="error_tip">{{ errorMsg }}</span> -->
									<span v-if="!errorMsg" style="color:#888E98 ;" class="error_tip">{{ L['密码不少于10位，包含英文字母大小写、特殊符号、数字至少3种类型'] }}</span>
									<span v-if="errorMsg" style="color:red;" class="error_tip">{{ errorMsg }}</span>
									<a href="javascript:void(0)"
									:disabled="!isPasswordsValid "
									:class="{ 'login_btn': true, 'disabled': !isPasswordsValid }" 
									@click="nextStep" class="login_btn">{{
										L['确定']
									}}</a>
									<!-- <button class="login_btn btn_total" :disabled="!isPasswordsValid || passwordsDontMatch" @click="submitReset">{{ L['确定'] }}</button> -->
								</div>
							</template>

							<!-- 成功提示 -->
							<template v-else-if="currentStep === 4">
								<div class="center">
									<img class="reset_password_pic" src="../../../assets/user/reset_password.png" alt="">
									<p class="tip_newpassword">{{ L['新密码设置完成'] }}</p>
								<!-- <button @click="goToLogin">{{ L['返回登陆页面'] }}</button> -->
								<a href="javascript:void(0)"
								@click="resetPasswordVisible = false && loginType == 2" 
								class="login_btn">{{
										L['登录']
									}}</a>	
								<!-- <button class="login_btn btn_total" @click="resetPasswordVisible = false">{{ L['登录'] }}</button> -->
								</div>
								
								
							</template>
						</div>
					</template>
					<!-- 重置密码界面 end-->
					<div 
					v-if="!resetPasswordVisible && !QRcodeLogin"
					:class="{
						bottom: true,
						flex_row_between_center: wxEnable == 1,
						flex_row_end_center: wxEnable != 1
					}">
						<div class="bottom_tip"><span style="margin-right: 10px;"></span>其他登录方式<span style="margin-left: 10px;"></span></div>
						<!-- <div class="bottom_tip scan" 
						:class="{ active: currentLoginMethod === 'app' }"
						@click="switchLoginMethod('app')"
						v-if="appEnable == 1 && currentLoginMethod === 'wechat'">AAP扫码</div> -->
						<!-- <img @click="goToPage('/weixin')" src="../../../assets/user/weixin.png" alt=""  /> -->
						<img @click="goTowxPage" src="../../../assets/user/weixin.png" alt=""  />
						<!-- <div style="display: flex;">
							<a href="javascript:void(0)" @click="goToPage('/register')">{{
								L['立即注册']
							}}</a>
							<router-link tag="a" :to="`/pwd/forget`">{{
								L['忘记密码']
							}}</router-link>
						</div> -->
					</div>

					<!-- 安全验证start -->
					<!-- <template> -->
						<!-- <div class="safe_confirm" v-if="isConfirmed">
							<div class="title">安全验证</div>
							<img class="pic" src="../../../assets/test_logo.png" alt="">
							<button class="btn">验证成功</button>
							<img class="close_btn" src="../../../assets/user/button_tanchuang_quxiao.png" alt="">
						</div>	 -->
					<!-- </template> -->

					<!-- 安全验证end -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { useRouter, onBeforeRouteLeave, useRoute } from 'vue-router'
import { ref, getCurrentInstance, onMounted, watch,computed,onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { ElMessage,ElMessageBox } from 'element-plus'
export default {
	name: 'LoginIndex',
	setup () {
		const store = useStore()
		const router = useRouter()
		const route = useRoute()
		const { proxy } = getCurrentInstance()
		const L = proxy.$getCurLanguage();
		const loadAdvsList = ref([])
		const loadImg = ref("");
    const loadpageColor = ref({});
		const loadInfo = ref({});
		const loadData = ref({});
		const userAgreement = ref('');
		const agreementCodes = ref('');
		const isTooltipVisible = ref(false);
		const isReplyVisible = ref(false);
		const isConfirmed = ref(false);
		const keyEnter = ref(true)
		const agreeWx =ref(false)
		const errorMsg = ref() //错误提示
		const name = ref('') //用户名
		const password = ref('') //密码
		const smsCode = ref('') //验证码
		const isSmsButtonActive = ref(true);
		const allAgreed = ref(false);
		const termsAgreed = ref(false);
		const privacyAgreed = ref(false);
		const ageAgreed = ref(false);
		const showPassword = ref(false);
    // 分别控制新密码和确认密码的可见性
		const showNewPassword = ref(false);
		const showConfirmPassword = ref(false);
		const loginType = ref(2) //登陆类型：1-账号密码登陆，2-手机验证码登陆
		const clickSmscode = ref(false) //是否获取验证码中
		const countDownM = ref(0) //短信验证码倒计时
		const timeOutId = ref('') //定时器的返回值
		const hasSentCode = ref(false); // 是否已发送过验证码
		const configInfo = ref(store.state.configInfo)
		const defaultImg = ref(
			'this.src="' + require('../../../assets/header/logo.png') + '"'
		)
		const defaultBgImg = ref(
			'this.src="' + require('../../../assets/login_bg.png') + '"'
		)
		const fromurl = ref('')
		const wxEnable = ref('')
		const pcAppid = ref('')
		const appEnable = ref(0)
		const currentLoginMethod = ref('app'); // 默认选择AAP扫码登录
		/* 二维码登录 */
		const QRlogShow = ref('')
		const QRissend = ref(null) //二维码登录定时器
		const QRcheck = ref(null) //二维码循环定时器
		const QRsuccess = ref(false) //二维码登录成功
		const QRScansuccess = ref(false) //二维码扫码成功
		const QRout = ref(false) //二维码是否过期
		const QRcodeLogin = ref(false) //二维码登录
		// 微信扫码
		const wxQRlogShow = ref('')
		const wxQRout = ref(false) //二维码是否过期
		const wxQRsuccess = ref(false) //二维码登录成功
		const wxQRissend = ref(null) //二维码登录定时器
		const wxQRcheck = ref(null) //二维码循环定时器
		const resetPasswordVisible = ref(false);
		const qrCode = require('../../../assets/qrcode_img.png');
		const qrLogin = require('../../../assets/qrLogin.png');
		const idCode = require('../../../assets/computer.png');
		const idLogin = require('../../../assets/idLogin.png');
		const isHoveredPic = ref(false)
		/* 二维码登录 */
		
		// 安全验证

		// 安全验证

		// 状态管理		
		const currentStep = ref(1);	
		const verificationCode = ref('');
		const newPassword = ref('');
		const confirmPassword = ref('');
		// const showPassword = ref(false);
		
		
		// 验证状态
		const isUsernameOrPhoneValid = computed(() => name.value.length === 11);
		const isVerificationCodeValid = computed(() => verificationCode.value.length === 6);
		const isPasswordsValid = computed(() => newPassword.value && confirmPassword.value );
		const passwordsDontMatch = computed(() => newPassword.value !== confirmPassword.value);
		//计算属性：判断表单是否有效
		const isFormValid = computed(() => {
			return allAgreed.value && termsAgreed.value && privacyAgreed.value && ageAgreed.value  && (password.value || smsCode.value);
		});
		const isAgreeAll = computed(() => {
			return allAgreed.value && termsAgreed.value && privacyAgreed.value && ageAgreed.value ;
		});
		
		// 密码类型切换
		const passwordFieldType = computed(() => showPassword.value ? 'text' : 'password');
		const newPasswordFieldType = computed(() => showNewPassword.value ? 'text' : 'password');
		const confirmNewPasswordFieldType = computed(() => showConfirmPassword.value ? 'text' : 'password');
		// 方法
		const validateInput = (field) => {
			switch (field) {
				case 'name':
					break;
				case 'verificationCode':
					break;
				case 'newPassword':
				case 'confirmPassword':
					break;
			}
		};

		console.log("configInfo",configInfo)

		const nextStep = async () => {
    // 清除之前的错误信息
    errorMsg.value = '';
		hasSentCode.value = false; 
		isSmsButtonActive.value = true; // 禁用验证码按钮
		let param = {}
		param.mobile = name.value
		param.verifyCode = verificationCode.value

    switch (currentStep.value) {
        case 1:
            if (!isUsernameOrPhoneValid.value) {
                errorMsg.value = L['请输入手机号'];
                return;
            }
            
            currentStep.value++;
            break;

        case 2:
				let checkMobile = proxy.$checkPhone(param.mobile);
            if (checkMobile !== true) {
                errorMsg.value = checkMobile;
                return;
            }

            if (!param.verifyCode) {
                errorMsg.value = L['请输入短信验证码'];
                return false;
            }

            try {
                let checkSmsCode = await proxy.$checkSmsCode(param.verifyCode);
                if (checkSmsCode !== true) {
                    errorMsg.value = checkSmsCode;
                    return false;
                }

                const res = await proxy.$get('/v3/msg/front/commons/verifyCodeCheck', param);
                console.log('Verify code check response:', res); // 调试信息
                if (res.state !== 200) {
                    errorMsg.value = res.msg;
                    return false;
                }

                // 验证码验证成功，继续下一步
                currentStep.value++;
            } catch (error) {
                console.error('Error during verify code check:', error); // 错误信息
                errorMsg.value = L['发生错误，请稍后再试'];
                return false;
            }
            break;

        case 3:
            if (passwordsDontMatch.value) {
                errorMsg.value = L['2次输入密码需要保持一致'];
                return;
            }
            const checkPwd = proxy.$checkPwd(newPassword.value);
            if (checkPwd !== true) {
                errorMsg.value = checkPwd;
                return;
            }
						// const checkSmsCode = proxy.$checkSmsCode(verificationCode.value);
            // if (checkSmsCode !== true) {
            //     errorMsg.value = checkSmsCode;
            //     return;
            // }

            let request = {
                memberMobile: name.value,
                loginPwd: proxy.$base64Encrypt(newPassword.value),
                verifyCode: param.verifyCode
            };
            

            try {
                const res = await proxy.$post('v3/member/front/memberPassword/resetLoginPwd', request);
                if (res.state === 200) {
                    ElMessage.success(res.msg);
										currentStep.value++;
                    // setTimeout(() => {
                    //     router.back();
                    // }, 500);
                    resetFields();
                } else {
                    errorMsg.value = res.msg;
                }
            } catch (error) {
                errorMsg.value = L['发生错误，请稍后再试'];
                console.error(error);
            }
            break;

        default:
            break;
    }
};

			// 辅助函数：重置字段
			const resetFields = () => {
					name.value = '';
					newPassword.value = '';
					password.value = '';
					confirmPassword.value = '';
					verificationCode.value = '';
					allAgreed.value = '';
					termsAgreed.value = '';
					privacyAgreed.value = '';
					ageAgreed.value = '';
					clearTimeout(timeOutId.value)
					countDownM.value = 0
					errorMsg.value = ''
					hasSentCode.value = false; 
					isSmsButtonActive.value = true; // 禁用验证码按钮
					// preventFre.value = false
					// clearTimeout(timeOutId.value)
					// countDownM.value = 0
					// timeOutId.value = null

			};

		
		// 收不到验证码提示
		const handleConfirmOpen = () => {
			const messageContent = `
				<ol>
					<li class='first'>1、网络延迟
						<ul class='second'>
							<li>网络可能存在延迟，请稍等一会儿或重新获取验证码</li>
						</ul>
					</li>
					<li class='first'>2、运营商屏蔽
						<ul class='second'>
							<li>如果退订或者向运营商投诉过此类通知短信，使得包含验证码的短信被运营商屏蔽，请拨打运营商电话咨询</li>
						</ul>
					</li>
					<li class='first'>3、短信黑名单
						<ul class='second'>
							<li>您可能曾经把此类短信加入黑名单，因此无法收到验证码，您可以从黑名单移除后重新尝试</li>
						</ul>
					</li>
					<li class='first'>4、短信次数限制
						<ul class='second'>
							<li>为避免短信骚扰及资源浪费，每个手机号每天最多发送5条短信，超过则当天不会再收到短信</li>
						</ul>
					</li>
				</ol>
			`;

			ElMessageBox.alert(messageContent, '收不到验证码', {
				customClass: 'confrimCode', // 添加自定义类名
				showConfirmButton: false, // 不显示确认按钮
				dangerouslyUseHTMLString: true, // 启用 HTML 内容解析
			});
		};

		// const switchLoginMethod = (method) => {
		// 	resetPasswordVisible.value = false; // 确保不在重置密码模式下
		// 	if (!QRcodeLogin.value) {
		// 		// 如果当前不是二维码登录模式，则切换到二维码登录模式，并默认选择微信扫码
		// 		QRcodeLogin.value = true;
		// 		currentLoginMethod.value = method;
		// 		if (method === 'wechat' && !wxQRissend.value) {
		// 			wxcreateQRcode();
		// 		}
			
		// 	} else {
		// 		// 如果已经在二维码登录模式，则仅切换登录方式
		// 		currentLoginMethod.value = method;
		// 		if (method === 'wechat' && !wxQRissend.value) {
		// 			wxcreateQRcode();
		// 		}else if(method === 'app' && !QRissend.value){
		// 			createQRcode();
		// 		}

		// 	}
			
		// };

		//由于这里的回车键触发事件和商品搜索框的回车键触发事件冲突，引入keyEnter变量判断
		document.onkeydown = function () {
			var key = window.event.keyCode
			if (key == 13 && keyEnter.value) {
				login()
			}
		}
		const showTooltip = (index) =>{
			switch (index) {
        case 1:
            isTooltipVisible.value = true;
						isHoveredPic.value = true;
            break;
        case 2:
            isReplyVisible.value = true;
            break;
				case 3:
						isConfirmed.value = true;
						break;
        default:
            console.log('未知的索引:', index);
    }
			
		}

		const hideTooltip = (index) =>{
			switch (index) {
        case 1:
            isTooltipVisible.value = false;
						isHoveredPic.value = false;
            break;
        case 2:
            isReplyVisible.value = false;
            break;
				case 3:
						isConfirmed.value = false;
						break;		
        default:
            console.log('未知的索引:', index);
    }
		}
		const login = () => {
			let param = {}
			param.username = name.value
			param.password = password.value
			param.smsCode = smsCode.value
			param.loginType = loginType.value
			param.source = 1
			param.agreementInfo = JSON.stringify(agreementCodes.value); // 添加agreementInfo字段
			if (param.loginType == 1) {
				//账号、手机号的验证
				if (!param.username) {
					errorMsg.value = L['请输入账号/手机号']
					return false
				} else {
					let checkName = proxy.$checkMemberName(param.username)
					if (checkName !== true) {
						//继续验证是否是手机号
						let checkMobile = proxy.$checkPhone(param.username)
						if (checkMobile !== true) {
							errorMsg.value = L['用户名或密码不正确']
							return false
						}
					}
				}

				//密码校验
				if (!param.password) {
					errorMsg.value = L['请输入密码']
					return false
				} else {
					// let checkPwd = proxy.$checkPwd(param.password)
					let checkPwd = true; // 登录不需要校验密码
					if (checkPwd !== true) {
						errorMsg.value = checkPwd
						return false
					}
				}
				param.password = proxy.$base64Encrypt(param.password)
			} else {
				//手机号验证
				if (!param.username) {
					errorMsg.value = L['请输入手机号']
					return false
				} else {
					let checkMobile = proxy.$checkPhone(param.username)
					if (checkMobile !== true) {
						errorMsg.value = checkMobile
						return false
					}
				}

				//验证码校验
				if (!param.smsCode) {
					errorMsg.value = L['请输入短信验证码']
					return false
				} else {
					let checkSmsCode = proxy.$checkSmsCode(param.smsCode)
					if (checkSmsCode !== true) {
						errorMsg.value = checkSmsCode
						return false
					}
				}
			}
			//如果未登录vuex中有购物车数据，需同步到该用户
			let cartInfo = []
			let cartListData = store.state.cartListData
			if (JSON.stringify(cartListData) != '{}') {
				cartListData.storeCartGroupList.map(cartListItem => {
					cartListItem.promotionCartGroupList.map(promotItem => {
						promotItem.cartList.map(cartItem => {
							cartInfo.push({
								productId: cartItem.productId,
								buyNum: cartItem.buyNum
							})
						})
					})
				})
			}
			param.cartInfo = JSON.stringify(cartInfo)
			if(param.loginType == 1){
				proxy.$post('v3/frontLogin/oauth/token', param).then(res => {
				if (res.state == 200) {
					if(res.data.loginPasswordNull === 1 || res.data.loginPasswordNull === 0){
						ElMessageBox.confirm(
							'为了您的账户安全，请重新设置密码',
							'安全提示',
							{
								confirmButtonText: '立即修改',
								cancelButtonText: '暂不修改',
								type: '',
								showClose: false, // 隐藏关闭按钮
								center:true,
								closeOnClickModal: false, // 点击遮罩不关闭对话框
    						modal: true, // 不显示遮罩层
								customClass: 'custom-message-box', // 添加自定义类名
							}
						).then(() => {
							clearTimeout(timeOutId.value)
							countDownM.value = 0
							errorMsg.value = ''
							// 用户选择了“立即修改”
							changeToResetPassword();
						}).catch(() => {
	
							countDownM.value = 60;
							countDown();
									});

					}else{
						localStorage.setItem('access_token', res.data.access_token);
						localStorage.setItem('refresh_token', res.data.refresh_token);
						localStorage.setItem('time', new Date().getTime().toString()); // 存储refresh_token更新时间

						// 获取用户信息，并同步信息到vuex
						proxy.$get('v3/member/front/member/getInfo').then(userInfoRes => {
							if (userInfoRes.state == 200) {
								store.commit('updateMemberInfo', userInfoRes.data);
								proxy.$getLoginCartListData(); // 更新购物车数据
								if (QRcodeLogin.value) {
									clearTimeout(QRissend.value);
									clearInterval(QRcheck.value);
									clearTimeout(wxQRissend.value);
									clearInterval(wxQRcheck.value);
									QRissend.value = null;
									QRcheck.value = null;
									wxQRissend.value = null;
									wxQRcheck.value = null;
									router.replace({ path: '/' });
								}
								// if (window.history.state.back) {
								// 	router.back();
								// } 
								else {
									router.replace({ path: '/' });
								}
							}
						});
						countDownM.value = 60;
						countDown();
					}
						
							} else {
								errorMsg.value = res.msg
							}
							let eventParams = {
								login_type: 1,
								is_success: res.state == 200 ? true : false,
								fail_errorcode:res.state,
								fail_reason: res.msg
							}
							proxy.$drgStatEvent('amall_login_fe', eventParams)
						})
			}else{
				// 构建请求参数
				const requestData = {
                mobile: param.username,
                smsCode: param.smsCode,
                source: param.source,
                agreementInfo: param.agreementInfo
            };
				proxy.$post('v3/member/front/login/freeSecretLogin', requestData).then(res => {
				if (res.state == 200) {
					localStorage.setItem('access_token', res.data.access_token);
				localStorage.setItem('refresh_token', res.data.refresh_token);
				localStorage.setItem('time', new Date().getTime().toString()); // 存储refresh_token更新时间

				// 获取用户信息，并同步信息到vuex
				proxy.$get('v3/member/front/member/getInfo').then(userInfoRes => {
					if (userInfoRes.state == 200) {
						store.commit('updateMemberInfo', userInfoRes.data);
						proxy.$getLoginCartListData(); // 更新购物车数据
						if (QRcodeLogin.value) {
							clearTimeout(QRissend.value);
							clearInterval(QRcheck.value);
							clearTimeout(wxQRissend.value);
							clearInterval(wxQRcheck.value);
							QRissend.value = null;
							QRcheck.value = null;
							wxQRissend.value = null;
							wxQRcheck.value = null;
						}
						// if (window.history.state.back) {
						// 	router.back();
						// } 
						else {
							router.replace({ path: '/member/info' });
						}
					}
				});

				countDownM.value = 60;
				countDown();
				} else {
					errorMsg.value = res.msg
				}
				let eventParams = {
					login_type: 1,
					is_success: res.state == 200 ? true : false,
					fail_errorcode:res.state,
					fail_reason: res.msg
				}
				proxy.$drgStatEvent('amall_login_fe', eventParams)
			})
			}

		}

			// 		// 登录成功后的处理逻辑
			// const handleNormalLogin = (res) => {
			// 	localStorage.setItem('access_token', res.data.access_token);
			// 	localStorage.setItem('refresh_token', res.data.refresh_token);
			// 	localStorage.setItem('time', new Date().getTime().toString()); // 存储refresh_token更新时间

			// 	// 获取用户信息，并同步信息到vuex
			// 	proxy.$get('v3/member/front/member/getInfo').then(userInfoRes => {
			// 		if (userInfoRes.state == 200) {
			// 			store.commit('updateMemberInfo', userInfoRes.data);
			// 			proxy.$getLoginCartListData(); // 更新购物车数据
			// 			if (QRcodeLogin.value) {
			// 				clearTimeout(QRissend.value);
			// 				clearInterval(QRcheck.value);
			// 				QRissend.value = null;
			// 				QRcheck.value = null;
			// 			}
			// 			if (window.history.state.back) {
			// 				router.back();
			// 			} else {
			// 				router.replace({ path: '/member/index' });
			// 			}
			// 		}
			// 	});

			// 	countDownM.value = 60;
			// 	countDown();
			// };


		//清空输入框内容
		const clearInputVal = type => {
			if (type == 'name') {
				name.value = ''
			} else if (type == 'password') {
				password.value = ''
			}
			else if(type == 'smsCode'){
				smsCode.value = ''
			}
		}
		//登录方式切换
		const changeLoginType = type => {
			loginType.value = type
			name.value = ''
			password.value = ''
			errorMsg.value = ''
			allAgreed.value = '';
			termsAgreed.value = '';
			privacyAgreed.value = '';
			ageAgreed.value = '';
		}
		//获取短信验证码
		const getSmsCode = () => {
			if (clickSmscode.value) {
				return
			} else if (countDownM.value) {
				return false
			}
			clickSmscode.value = true
			let checkMobile = proxy.$checkPhone(name.value)
			if (checkMobile !== true) {
				errorMsg.value = checkMobile
				clickSmscode.value = false
			} else {
				let param = {}
				param.mobile = name.value
				param.type = 'wxAuth'
				proxy.$get('v3/msg/front/commons/smsCode', param).then(res => {
					if (res.state == 200) {
						hasSentCode.value = true; // 标记已发送验证码
						isSmsButtonActive.value = false; // 禁用验证码按钮
						countDownM.value = 60
						countDown()
						clickSmscode.value = false
					} else {
						//提示错误
						errorMsg.value = res.msg
						clickSmscode.value = false
					}
				})
			}
		}
		//倒计时
		const countDown = () => {
			countDownM.value--
			if (countDownM.value == 0) {
				isSmsButtonActive.value = true; 
				clearTimeout(timeOutId.value)
			} else {
				timeOutId.value = setTimeout(countDown, 1000)
			}
		}
		//通过replace方式跳转页面
		const goToPage = (type,action) => {
			router.push({
				path: type,
				query: { action }, // 使用查询参数传递动作
			})
		}

		// 微信二维码登录
		const wetChatLogin = () => {
			let href = `https://open.weixin.qq.com/connect/qrconnect?appid=${pcAppid.value
				}&redirect_uri=${encodeURIComponent(
					fromurl.value
				)}&response_type=code&scope=snsapi_login&state=2or3m#wechat_redirect`
			window.open(href, '_blank')
		}

		const getWxEnbale = () => {
			proxy
				.$get('v3/system/front/setting/getSettings', {
					names: 'login_wx_pc_is_enable,login_wx_pc_appid,use_model_app'
				})
				.then(res => {
					if (res.state == 200) {
						wxEnable.value = res.data[0]
						pcAppid.value = res.data[1]
						appEnable.value = res.data[2]
					}
				})
		}

		// 切换账号密码/二维码登录
		const changeQrlog = () => {
			QRcodeLogin.value = !QRcodeLogin.value
			if (QRcodeLogin.value) {
			currentLoginMethod.value = 'app'; // 默认进入二维码登录时选择微信扫码
			if (!QRissend.value) {
				createQRcode();
			}
		}

			resetPasswordVisible.value = false; // 确保不在重置密码模式下
		}

		// 切换到重置密码界面
		const changeToResetPassword = () => {
				resetPasswordVisible.value = true;
				QRcodeLogin.value = false; // 确保不是二维码登录模式
				currentStep.value = 1; // 重置到第一步
				window.history.pushState({ resetPassword: true }, '');
		};
		// 返回登录界面
    const backToLogin = () => {
      resetPasswordVisible.value = false;
    };

    // 监听 popstate 事件，处理浏览器的后退/前进按钮
    const handlePopState = (event) => {
			console.log('popstate event triggered', event.state); // 添加更多调试信息
      if (resetPasswordVisible.value && event.state && event.state.resetPassword) {
				console.log('czmmmmmmm')
        backToLogin();
      }
			// 如果没有自定义状态属性，尝试通过其他属性判断是否需要返回登录
      else if (resetPasswordVisible.value && event.state && event.state.back === '/' && event.state.current === '/login') {
        console.log('Returning to login based on history state');
        backToLogin();
      }
    };

		// 卸载时移除 popstate 事件监听器
    onBeforeUnmount(() => {
      window.removeEventListener('popstate', handlePopState);
    });

		// // 微信--刷新二维码
		// const wxreCreateQRcode = () => {
		// 	setTimeout(() => {
		// 		wxQRout.value = false
		// 		wxcreateQRcode()
		// 	}, 200)
		// }

		// // 生成二维码 (过期定时器、获取扫码状态定时器)
		// const wxcreateQRcode = () => {
		// 	proxy.$get('v3/member/front/wx/qr/login/createQrCode').then(res => {
		// 		/* 二维码图片 */
		// 		wxQRlogShow.value = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.ticket
		// 		/* 过期定时器 */
		// 		wxQRissend.value = setTimeout(() => {
		// 			console.log('-----二维码过期-----')
		// 			clearTimeout(wxQRissend.value)
		// 			clearInterval(wxQRcheck.value)
		// 			wxQRissend.value = null
		// 			wxQRcheck.value = null
		// 			wxQRout.value = true
		// 		}, 300000)
		// 		/* ------ end ------ */

		// 		let param = {
		// 			ticket: res.data.ticket
		// 		}
		// 		/* 获取扫码状态定时器 */
		// 		wxQRcheck.value = setInterval(() => {
		// 			proxy
		// 				.$post('v3/member/front/wx/qr/login/progress', param)
		// 				.then(result => {
		// 					if(result.data.status == 1){
		// 						console.log('-----已扫码-----')
		// 					}
		// 					if (result.data.status == 2) {
		// 						console.log('-----授权登录成功-----')
		// 						wxQRsuccess.value = true
		// 						clearTimeout(wxQRissend.value)
		// 						clearInterval(wxQRcheck.value)
		// 						wxQRissend.value = null
		// 						wxQRcheck.value = true

		// 						localStorage.setItem('refresh_token', result.data.refreshToken)
		// 						/* 更新 access_token */
		// 						let params = new FormData()
		// 						params.append('grant_type', 'refresh_token')
		// 						params.append('refresh_token', result.data.refreshToken)
		// 						params.append('source', 1)

		// 						proxy.$post('v3/frontLogin/oauth/token', params, {
		// 							headers: {
		// 								'Content-Type': 'multipart/form-data',
		// 								Authorization: 'Basic ZnJvbnQ6ZnJvbnQ='
		// 							}
		// 						}).then(
		// 							response => {
		// 								if (response.state == 200) {
		// 									localStorage.setItem('access_token', response.data.access_token)
		// 									localStorage.setItem('time', new Date().getTime().toString()) //存储refresh_token更新时间

		// 									/* 获取用户信息，并同步信息到vuex */
		// 									proxy.$get('v3/member/front/member/getInfo').then(res_info => {
		// 										if (res_info.state == 200) {
		// 											store.commit('updateMemberInfo', res_info.data)
		// 											proxy.$getLoginCartListData() //更新购物车数据
		// 											if (window.history.state.back) {
		// 												router.back()
		// 											} else {
		// 												router.replace({ path: '/member/index' })
		// 											}
		// 										}
		// 									})
		// 									/* ------ end ------ */
		// 								}
		// 							},
		// 							err => {
		// 								console.log('更新access_token出错：', err)
		// 							}
		// 						)
		// 						/* ------ end ------ */
		// 					}
		// 				})
		// 		}, 3000)
		// 		/* ------ end ------ */
		// 	})
		// }

		// 刷新二维码
		const reCreateQRcode = () => {
			setTimeout(() => {
				QRout.value = false
				createQRcode()
			}, 200)
		}

		// 生成二维码 (过期定时器、获取扫码状态定时器)
		const createQRcode = () => {
			proxy.$get('v3/member/front/qr/login/createQr').then(res => {
				/* 二维码图片 */
				QRlogShow.value = 'data:image/png;base64,' + res.data.image
				/* 过期定时器 */
				QRissend.value = setTimeout(() => {
					console.log('-----二维码过期-----')
					clearTimeout(QRissend.value)
					clearInterval(QRcheck.value)
					QRissend.value = null
					QRcheck.value = null
					QRout.value = true
				}, 300000)
				/* ------ end ------ */

				let param = {
					u: res.data.u
				}
				/* 获取扫码状态定时器 */
				QRcheck.value = setInterval(() => {
					proxy
						.$post('v3/member/front/qr/login/progress', param)
						.then(result => {
							if(result.data.progress == 1){
								// console.log('-----扫码成功，请登录-----')
								// QRScansuccess.value = true
								console.log('-----等待授权-----')
							}
							if (result.data.progress == 2) {
								QRScansuccess.value = false
								console.log('-----授权登录成功-----')
								QRsuccess.value = true
								clearTimeout(QRissend.value)
								clearInterval(QRcheck.value)
								QRissend.value = null
								QRcheck.value = true

								localStorage.setItem('refresh_token', result.data.refreshToken)
								/* 更新 access_token */
								let params = new FormData()
								params.append('grant_type', 'refresh_token')
								params.append('refresh_token', result.data.refreshToken)
								params.append('source', 1)

								proxy.$post('v3/frontLogin/oauth/token', params, {
									headers: {
										'Content-Type': 'multipart/form-data',
										Authorization: 'Basic ZnJvbnQ6ZnJvbnQ='
									}
								}).then(
									response => {
										if (response.state == 200) {
											localStorage.setItem('access_token', response.data.access_token)
											localStorage.setItem('time', new Date().getTime().toString()) //存储refresh_token更新时间

											/* 获取用户信息，并同步信息到vuex */
											proxy.$get('v3/member/front/member/getInfo').then(res_info => {
												if (res_info.state == 200) {
													store.commit('updateMemberInfo', res_info.data)
													proxy.$getLoginCartListData() //更新购物车数据
													if (window.history.state.back) {
														router.back()
													} else {
														router.replace({ path: '/' })
													}
												}
											})
											/* ------ end ------ */
										}
										 let eventParams = {
											login_type: 4,
											is_success: response.state == 200 ? true : false,
											fail_errorcode:response.state,
											fail_reason: response.msg
										}
										proxy.$drgStatEvent('amall_login_fe', eventParams)
									},
									err => {
										console.log('更新access_token出错：', err)
									}
								)
								/* ------ end ------ */
							}
						})
				}, 3000)
				/* ------ end ------ */
			})
		}

		// 切换指定密码输入框的可见性
		const togglePasswordVisibility = (type) => {
			switch (type) {
				case 'new':
					showNewPassword.value = !showNewPassword.value;
					break;
				case 'old':
					showPassword.value = !showPassword.value; // 使用新的状态变量
					break;
				case 'confirm':
					showConfirmPassword.value = !showConfirmPassword.value;
					break;
				default:
					console.log('未知的密码类型:', type);
			}
		};

		// 全选/取消全选的方法
		const toggleAll = () => {
			termsAgreed.value = allAgreed.value;
			privacyAgreed.value = allAgreed.value;
			ageAgreed.value = allAgreed.value;
		};

		


		const getAgreementData = async (arr, type) => {
			let config = {
				headers: {
					"Content-Type": "application/json",
					// 'Authorization': "Bearer " + localStorage.getItem("access_token"),
				},
			};

			// 确保使用正确的参数名 'agreementCodes'
			let param = {
				agreementCodes: ['register_agreement','privacy_policy','asus_user_privacy'], // 使用正确的参数名
			};

			proxy.$post("v3/system/front/agreement/list", param, config)
				.then((res) => {
					// console.log('完整响应:', res); 
					if (res.state === 200) {
						console.log('成功获取的数据:', res.data);	
						agreementCodes.value = res.data.map(agreement => ({
							agreementCode: agreement.agreementCode,
							versionNo: agreement.versionNo
						}));
						console.log('agreementCodes成功获取的数据:', agreementCodes.value);
						userAgreement.value=res.data[0];
						console.log('userAgreement成功获取的数据:', userAgreement.value);
						// privacy.value=res.data[1];
						// asus_user_privacy.value=res.data[2];
						// decorateData.data.map((item) => {
						// 	if (item.json_data.type === type) {
						// 		item.json_data.info = response.data;
						// 	}
						// });
					} else {
						console.error('请求失败，状态码:', res.state, ', 错误信息:', res.msg || '无');
					}
				})
				.catch((error) => {
					console.error('请求过程中发生错误:', error);
				});
		};

		watch([name, password, termsAgreed, privacyAgreed, ageAgreed,smsCode], () => {
			if (loginType.value == 1) {
				password.value = password.value.substring(0, 20)
				name.value = name.value.substring(0, 20)
			} else {
				password.value = password.value.substring(0, 6)
				name.value = name.value.substring(0, 20)
			}

			if (password.value || name.value) {
				errorMsg.value = ''
			}

			// 更新全选复选框的状态
  		allAgreed.value = [termsAgreed.value, privacyAgreed.value, ageAgreed.value].every((value) => value);
		})

		onMounted(() => {
			getloadAdv()
			getAgreementData()
			window.addEventListener('popstate', handlePopState);
			getWxEnbale()
			if (route.query.redirectUrl) {
				fromurl.value =
					window.location.origin + decodeURIComponent(route.query.redirectUrl)
			} else {
				fromurl.value = window.location.origin
			}

			if (route.query.error) {
				ElMessage.error(decodeURIComponent(route.query.error))
			}
		})

		onBeforeRouteLeave(() => {
			keyEnter.value = false
		})

		// const goTowxPage = () =>{
		// 	if(!isAgreeAll){
		// 		agreeWx.value == true;
		// 		if(isAgreeAll){
		// 			goToPage('/weixin','createWxQRCode')
		// 		}
		// 	}
			
		// }

const goTowxPage = () => {
  if (allAgreed.value) {
    // 如果全部勾选，执行跳转逻辑
    // console.log("执行跳转至微信页面的逻辑");
		goToPage('/weixin','createWxQRCode')
    // 这里可以替换为实际的页面跳转逻辑，比如使用 Vue Router 或者 window.location.href
  } else {
    // 若未全部勾选，则显示警告
    agreeWx.value = true;
  }
};
const load = ref([])
const getloadAdv = () => {
      let params = {
      }
        proxy.$post('v3/system/front/pcAdv/list', params).then(res => {
          if (res.state == 200) {
						loadAdvsList.value = res.data.loadAdvs
						console.log('loadAdvsList',loadAdvsList.value)
						loadAdvsList.value.forEach((i) => {
							let item = JSON.parse(i.data);
							
							item.toufangIsShow = true;
							if(item.deliverySettings){
								if (!handleTime(item.deliveryTime)) {
                  item.toufangIsShow = false;
                }else{

								}
								
							}
							i.datas = item;
						})
						load.value = loadAdvsList.value.filter(
							(e) => e.datas.toufangIsShow 
						);
						loadImg.value = load.value[0].datas.imgUrl;
						loadpageColor.value = load.value[0].datas.pageColor
						// loadInfo.value = load.datas;
						console.log("load========", load.value);
						// console.log('loadImg',loadImg.value)
						// console.log('loadpageColor',loadpageColor.value)
						// console.log('loadInfo',loadInfo.value)
          }
          else {
            ElMessage(res.msg)
          }
        })
       
    }

//跳转
const diyNavTo = (val) => {
	// console.log('kankanaknaknaknka=======',val)
      proxy.$diyNavTo(val)
    }
		return {
			L,
			getloadAdv,
			load,
			diyNavTo,
			loginType,
			loadImg,
			loadpageColor,
			loadInfo,
			loadData,
			goTowxPage,
			login,
			name,
			loadAdvsList,
			password,
			smsCode,
			backToLogin,
			handlePopState,
			clearInputVal,
			errorMsg,
			changeLoginType,
			getSmsCode,
			clickSmscode,
			countDownM,
			goToPage,
			configInfo,
			defaultImg,
			defaultBgImg,
			wetChatLogin,
			wxEnable,
			QRcodeLogin,
			QRissend,
			QRout,
			qrCode,
			qrLogin,
			idCode,
			isHoveredPic,
			idLogin,
			hasSentCode,
			// wxQRout,
			// wxQRsuccess,
			// wxQRlogShow,
			// wxQRissend,
			// wxQRcheck,
			// wxcreateQRcode,
			// wxreCreateQRcode,
			changeQrlog,
			reCreateQRcode,
			createQRcode,
			QRlogShow,
			QRcheck,
			QRsuccess,
			QRScansuccess,
			appEnable,
			toggleAll,
			allAgreed,
			termsAgreed,
			privacyAgreed,
			ageAgreed,
			isFormValid,
			agreeWx,
			isAgreeAll,
			showPassword,
			passwordFieldType,
			togglePasswordVisibility,
			showTooltip,
			hideTooltip,
			isTooltipVisible,
			isReplyVisible,
			isConfirmed,
			resetPasswordVisible,
			changeToResetPassword,
			currentStep,
			verificationCode,
			newPassword,
			confirmPassword,
			isUsernameOrPhoneValid,
			isVerificationCodeValid,
			isPasswordsValid,
			passwordsDontMatch,
			validateInput,
			nextStep,
			showConfirmPassword,
			showNewPassword,
			newPasswordFieldType,
			confirmNewPasswordFieldType,
			handleConfirmOpen,
			currentLoginMethod,
			// switchLoginMethod,
			// handleNormalLogin,
			//agreementInfo,
			resetFields,
			getAgreementData,
			userAgreement,
			agreementCodes,
			isSmsButtonActive

		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../../style/login.scss';

@media screen and (max-width: 1600px) {
	.bg {
		width: 1583px !important;
		/*图片宽度*/
		margin-left: calc(0px - 1583px/2) !important;
	}
}

.make_shadow {
	// box-shadow: 2px 2px 10px #eee inset;
	// width: 45px;
	// height: 45px;
	width:80px;
	height: 80px;
	position: relative;
	// padding-top: 6px;
	// padding-left: 6px;
	cursor: pointer;

	&:after {
		content: "";
		border: 40px solid #fff;
		border-top: 40px solid transparent;
		// border-left: 22px solid transparent;
		border-right: 40px solid transparent;
		position: absolute;
		right: 8px;
		bottom: 0;
	}
}
.icon_user{
	width: 24px;
	height: 24px;
}
.remind_user_one{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 500;
	font-size: 16px;
	color: #FFFFFF;
	padding-left: 10px;
	line-height: 38px;
	z-index: 999;
	position: absolute;
	top: 25px;
	right: 63px;
	width: 92px;
	height: 38px;
	background-color: transparent;
	border-radius: 6px 6px 6px 6px;
	background-size: cover; /* 确保图片覆盖整个元素 */
  background-repeat: no-repeat; /* 防止图片重复 */
	background-image: url('../../../assets/user/remind.png');
}
.remind_user_two{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 500;
	font-size: 16px;
	color: #FFFFFF;
	padding-left: 10px;
	line-height: 38px;
	z-index: 999;
	position: absolute;
	top: 25px;
	right: 63px;
	width: 147px;
	height: 38px;
	background-color: transparent;
	border-radius: 6px 6px 6px 6px;
	background-size: cover; /* 确保图片覆盖整个元素 */
  background-repeat: no-repeat; /* 防止图片重复 */
	background-image: url('../../../assets/user/remind2.png');
}
.agree_box{
		width: 142px;
		height: 44px;
		position: absolute;
		top: -46px;
		left: -3px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		background-size: cover; /* 确保图片覆盖整个元素 */
		background-repeat: no-repeat; /* 防止图片重复 */
		// background-image: url('/assets/user/agree_bg.png');
		background-image: url("../../../assets/user/agree_bg.png");
		
	}

.safe_confirm{
	z-index: 9999;
	background: #FFFFFF;
	border-radius: 8px 8px 8px 8px;
	position: relative;
	width: 567px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 0;
	right:600px;
	.title{
		font-family: Microsoft YaHei,Microsoft YaHei;
		font-weight: 500;
		font-size: 22px;
		color: #000000;
		line-height: 26px;
		margin-top: 50px;
	}
	.pic{
		width: 439px;
		height: 226px;
		border-radius: 8px 8px 8px 8px;
		margin-top: 30px;
		margin-bottom: 30px;
	}
	.btn{
		width: 437px;
		height: 46px;
		background: rgba(30,124,255,0.12);
		border-radius: 8px 8px 8px 8px;
		font-family: Microsoft YaHei,Microsoft YaHei;
		font-weight: 400;
		font-size: 20px;
		color: #1E7CFF;
		border: 1px solid rgba(30,124,255,0.12);
		line-height: 46px;
		margin-bottom: 30px;
	}
	.close_btn{
		position: absolute;
		top: 30px;
		right: 30px;
		width: 18px;
		height: 18px;
	}
}


.reset_password {
	height: 482px;
}

.btn_total{
	width: 400px;

}
// button {
//   width: 100%;
//   padding: 10px;
//   font-size: 16px;
//   color: #fff;
//   background-color: #409eff;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
//   transition: background-color 0.3s ease;
// }

// button.disabled {
//   background-color: #ccc;
//   cursor: not-allowed;
// }

// button:not(.disabled):hover {
//   background-color: #66b1ff;
// }


.tip_newpassword{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 500;
	font-size: 20px;
	color: #22253C;
	line-height: 30px;
	text-align: center;
	margin-top: 30px;
	padding-bottom: 15px;
}
.reset_password_pic{
	margin-left:165px ;
	margin-right: 165px;
	margin-top: 30px;
	width: 70px;
	height: 70px;
}

.error_tip{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 12px;
	color: #FF483E;
	line-height: 20px;
	display: inline-block;
	margin-top: 10px;
}


.qrMain_title {
	position: relative;
	// color: #999999;
	// font-size: 13px;
	// font-weight: 700;
	margin-top: 15px;
	margin-bottom: 132px;
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 18px;
	color: #888E98;
	line-height: 20px;
	display: flex;
	
}
.question_icon{
	width: 20px;
	height: 20px;

}
.reply_user{
	display: inline-block;
	position: absolute;
	top: -12px;
	right: 20px;
	width: 248px;
	height: 105px;
	padding: 19px 31px 17px 25px;
	background-color: transparent;
	border-radius: 6px 6px 6px 6px;
	// background-size: contain; /* 确保图片覆盖整个元素 */
	background-repeat: no-repeat; /* 防止图片重复 */
	background-size: 244px 105px; /* 宽度为100px，高度为100px */
	background-image: url('../../../assets/user/reply.png');
	.reply_itemO{
		font-family: Microsoft YaHei,Microsoft YaHei;
		font-weight: 500;
		font-size: 16px;
		color: #888E98;
		line-height: 20px;
		display: inline-block;
		margin-bottom: 2px;
	}
	.reply_itemT{
		font-family: Microsoft YaHei,Microsoft YaHei;
		font-weight: 500;
		font-size: 14px;
		color: rgba(136,142,152,0.6);
		line-height: 20px;
	}
}

/* 隐藏图标 */
::v-deep .custom-message-box .el-message-box__icon {
  display: none !important;
}
</style>
<style>
/* 自定义消息框样式 */

.el-message-box {
  width: 414px;
	/* height: 140px; */
	background: #FFFFFF;
	box-shadow: 0px 8px 20px 0px rgba(84,86,96,0.15);
	border-radius: 1px 1px 1px 1px;
	border: 1px solid #E0E0E0;
	
}
.el-message-box--center {
    padding-bottom: 20px!important;
}
.el-message-box--center .el-message-box__header {
    padding-top: 20px;
}
.custom-message-box .el-message-box__content {
    padding-top: 0px;
    padding-bottom: 11px;
}

.custom-message-box .el-message-box__title {
  font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 500;
	font-size: 15px;
	color: #22253C;
	line-height: 24px;
}

.custom-message-box .el-message-box__content{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	color: #808080;
	line-height: 18px;
}
.custom-message-box .el-message-box__btns .el-button {
	width: 100px;
	height: 34px;
	border-radius: 1px 1px 1px 1px;
	border: 1px solid #E0E0E0;
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	/* color: #888E98; */

}
.custom-message-box .el-message-box__btns .el-button .el-button--primary{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	color: #FFFFFF;
	/* background: #1E7CFF; */
	width: 100px;
	height: 34px;
	background: #1E7CFF;
	border-radius: 2px 2px 2px 2px;
}
.custom-message-box .el-message-box__btns button:nth-child(2){
	background-color: #1E7CFF!important;
}

.confrimCode{
	width: 552px;
	/* height: 461px; */
	background: #FFFFFF;
	border-radius: 0px 0px 0px 0px;
	padding: 0px;
}
.confrimCode .el-message-box__header {
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 500;
	font-size: 24px;
	color: #000000;
	border-bottom:1px solid  #EEEEEE;
	padding-bottom: 20px;
	padding-top: 20px;
	padding-left: 20px;
	
}
.confrimCode .el-message-box__header .el-message-box__title{
		font-family: Microsoft YaHei,Microsoft YaHei;
		font-weight: 500;
		font-size: 24px;
		color: #000000;
	}
.confrimCode .el-message-box__header .el-message-box__headerbtn{
	top: 20px;
	right: 20px;
}
.confrimCode .el-message-box__header .el-message-box__headerbtn .el-message-box__close{
	font-size: 24px;
	color: #828282 ;
}


.confrimCode .el-message-box__content{
	padding-top: 30px;
	padding-left: 30px;
	padding-right: 46px;	
}
.confrimCode .el-message-box__content .first{
	padding-bottom: 40px;
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
}
.confrimCode .el-message-box__content .second{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 500;
	font-size: 14px;
	color: #888E98;
	line-height: 16px;
}

/* .sld_login .sld_login_content .login .login_box .center [type=checkbox][data-v-1c1eeab1]{
	display: none;
}

.sld_login .sld_login_content .login .login_box .center .agreement-item label[data-v-1c1eeab1] ::before{
background-image: url('../../../assets/user/close.png');
background-size: cover;
} */


.agreement-item {
  display: inline-block;
  position: relative;
}

.agreement-item input[type="checkbox"] {
  /* 隐藏原始的复选框 */
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
	width: 16px; /* 根据图片大小调整 */
  height: 16px; /* 根据图片大小调整 */
}

.agreement-item .checkbox-custom {
	background-image: url('../../../assets/user/agree_no.png'); /* 替换为你的未选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 12px; /* 根据图片大小调整 */
  height: 12px; /* 根据图片大小调整 */
  display: inline-block;
  cursor: pointer;
}

.agreement-item input[type="checkbox"]:checked + .checkbox-custom {
	background-image: url('../../../assets/user/agree_choose.png'); /* 替换为你的选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
	width: 12px; /* 根据图片大小调整 */
  height: 12px; /* 根据图片大小调整 */
}
.agreement-item .checkbox-custom_all {
	background-image: url('../../../assets/user/agree_no.png'); /* 替换为你的未选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 14px; /* 根据图片大小调整 */
  height: 14px; /* 根据图片大小调整 */
  display: inline-block;
  cursor: pointer;
}

.agreement-item input[type="checkbox"]:checked + .checkbox-custom_all {
	background-image: url('../../../assets/user/agree_choose.png'); /* 替换为你的选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
	width: 14px; /* 根据图片大小调整 */
  height: 14px; /* 根据图片大小调整 */
}
</style>
